import { render, staticRenderFns } from "./baozhang.vue?vue&type=template&id=004519f7"
import script from "./baozhang.vue?vue&type=script&lang=js"
export * from "./baozhang.vue?vue&type=script&lang=js"
import style0 from "./baozhang.vue?vue&type=style&index=0&id=004519f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports